const defaultMeta = {
  label: "RangerVault",
  logo: `${process.env.PUBLIC_URL}/rangervault.png`,
};

const PAGE_META = {
  "/dashboard": {
    label: "Incident Management",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/my-vault": {
    label: "MyVault",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/supervisor": {
    label: "Supervisor",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/supervisor/history": {
    label: "Incident History",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/supervisor/analytics": {
    label: "Analytics",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/my-vault/training": {
    label: "RangerAcademy",
    logo: `${process.env.PUBLIC_URL}/rangeracademy.png`,
  },
  "/my-vault/profile": {
    label: "Ranger Profile",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/analytics": {
    label: "Analytics",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/training": {
    label: "RangerAcademy",
    logo: `${process.env.PUBLIC_URL}/rangeracademy.png`,
  },
  "/profile": {
    label: "Ranger Profile",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  // Support page removed
  "/admin-panel": {
    label: "Admin Panel",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/settings": {
    label: "Settings",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
  "/my-vault/resources": {
    label: "Resources",
    logo: `${process.env.PUBLIC_URL}/rangervault.png`,
  },
};

export const resolvePageMeta = (pathname) => {
  const entry = PAGE_META[pathname];
  if (!entry) {
    return defaultMeta;
  }

  const fallbackLogo = defaultMeta.logo;
  return {
    label: entry.label || defaultMeta.label,
    logo: entry.logo || fallbackLogo,
  };
};

export default PAGE_META;
